import React, { useState, useEffect, Fragment } from "react";

const useComapnyPolicyTable = (
    companyPolicyData,
    departments,
    handleDelCompanyPolicies,
    handleEditCompanyPolicies,
    onClickToggleFromTable,
    
) => {
  const [thead] = useState(["Policy Name","Description","Department","Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = companyPolicyData.map((el) => {
      var temp = new Array();
      temp = el.departmentId;
      let newarr=[];
      // temp.map(function (id){
        departments.map(function (desId) {
          if(desId.departmentId == parseInt(temp))
          {  
            newarr.push({val:desId.departmentName});
          }
        });
      // });
      
      const deprt=newarr.map(item => item.val).join(', ');

      return {
        "Policy Name": el.policyName,
        "Description": el.description,
        "Department":  deprt,
      Action: (
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    <i
      className="fas fa-edit "
      style={{ cursor: "pointer" }}
      onClick={() => {
        handleEditCompanyPolicies(el, el.companyPolicyId);
        onClickToggleFromTable();
      }}
    ></i>
    <i
      className="fas fa-trash "
      style={{ cursor: "pointer" }}
      onClick={() => handleDelCompanyPolicies(el.companyPolicyId)}
    ></i>
  </div>
),
      };
    });

     setTrow(trowArr);
  }, [
    companyPolicyData,
    handleDelCompanyPolicies,
    handleEditCompanyPolicies,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useComapnyPolicyTable;